import { Outlet } from 'react-router'
import Header from '../../../component/layout/header'
import useNav from '../../../component/custom-hooks/get-nav';

const PPCOrganizationLayout = () => {

  const navList = useNav();
  let {PPCTopNav, PPCOrgBottomNav} = navList;

  return (
    <div className="webBody">
      <Header bottomTabs={PPCOrgBottomNav} topTabs={PPCTopNav} />
      <Outlet />
    </div>
  )
}

export default PPCOrganizationLayout